"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getters = void 0;
var getters = {
  selectedDriver: function selectedDriver(state) {
    return state.selectedDriver;
  },
  trucks: function trucks(state) {
    return state.trucks;
  },
  bufferTrucks: function bufferTrucks(state) {
    return state.bufferTrucks;
  },
  selectedTruck: function selectedTruck(state) {
    return state.selectedTruck;
  },
  pagination: function pagination(state) {
    return state.pagination;
  },
  defaultPagination: function defaultPagination(state) {
    return state.defaultPagination;
  },
  defaultTableSize: function defaultTableSize(state) {
    return state.defaultTableSize;
  },
  defaultOrderColumns: function defaultOrderColumns(state) {
    return state.defaultOrderColumns;
  },
  selectedColumns: function selectedColumns(state) {
    return state.selectedColumns;
  },
  orderColumns: function orderColumns(state) {
    return state.orderColumns;
  },
  orderColumnTemplates: function orderColumnTemplates(state) {
    return state.orderColumnTemplates;
  },
  unassignedOrders: function unassignedOrders(state) {
    return state.unassignedOrders;
  },
  excludedOrders: function excludedOrders(state) {
    return state.excludedOrders;
  },
  includedOrders: function includedOrders(state) {
    return state.includedOrders;
  },
  selectedOrders: function selectedOrders(state) {
    return state.selectedOrders;
  },
  orderFilters: function orderFilters(state) {
    return state.orderFilters;
  },
  incidents: function incidents(state) {
    return state.incidents;
  },
  dateRangeOption: function dateRangeOption(state) {
    return state.dateRangeOption;
  },
  startDate: function startDate(state) {
    return state.startDate;
  },
  endDate: function endDate(state) {
    return state.endDate;
  },
  planDateRange: function planDateRange(state) {
    return state.planDateRange;
  },
  tableLoading: function tableLoading(state) {
    return state.tableLoading;
  },
  plan: function plan(state) {
    return state.plan;
  },
  anyChanges: function anyChanges(state) {
    return state.anyChanges;
  },
  isPlanExists: function isPlanExists(state) {
    return state.isPlanExists;
  },
  defaultLocationType: function defaultLocationType(state) {
    return state.defaultLocationType;
  },
  locationType: function locationType(state) {
    return state.locationType;
  },
  // orderLocationLists(state: MilkRunState): Array<string> {
  //   return state.orderLocationLists;
  // },
  // selectedLocation(state: MilkRunState): string {
  //   return state.selectedLocation;
  // },
  truckFilters: function truckFilters(state) {
    return state.truckFilters;
  },
  truckLoading: function truckLoading(state) {
    return state.truckLoading;
  },
  searchType: function searchType(state) {
    return state.searchType;
  },
  locations: function locations(state) {
    return state.locations;
  },
  failedOrders: function failedOrders(state) {
    return state.failedOrders;
  },
  savedOrderIds: function savedOrderIds(state) {
    return state.savedOrderIds;
  },
  isManualAssignLoading: function isManualAssignLoading(state) {
    return state.isManualAssignLoading;
  },
  isAssignedDriverChanges: function isAssignedDriverChanges(state) {
    return state.isAssignedDriverChanges;
  },
  isUnassignedDriverChanges: function isUnassignedDriverChanges(state) {
    return state.isUnassignedDriverChanges;
  },
  GLOBAL_SELECTED_ORDERS: function GLOBAL_SELECTED_ORDERS(state) {
    return state.GLOBAL_SELECTED_ORDERS;
  },
  GLOBAL_SELECTED_TRUCKS: function GLOBAL_SELECTED_TRUCKS(state) {
    return state.GLOBAL_SELECTED_TRUCKS;
  }
};
exports.getters = getters;